/* eslint-disable camelcase */
import React, { createContext, useState } from 'react'

type RecoverPasswordProps = {
  email: string
  sms: string
  canalType: string
}

type ContextProps = {
  recoverPasswordInfos: RecoverPasswordProps
  setRecoverPasswordInfos: React.Dispatch<
    React.SetStateAction<RecoverPasswordProps>
  >
}

export const Context = createContext<ContextProps>()

const ContextRecoverPasswordProvider = (props) => {
  const [recoverPasswordInfos, setRecoverPasswordInfos] =
    useState<RecoverPasswordProps>({
      email: '',
      sms: '',
      canalType: '',
    })

  const contextValue: ContextProps = {
    recoverPasswordInfos,
    setRecoverPasswordInfos,
    // updateCanalType,
  }

  return (
    <Context.Provider value={contextValue}>{props.children}</Context.Provider>
  )
}

export default ContextRecoverPasswordProvider
